import * as React from 'react';
import { Route, RouteComponentProps, Router, Switch } from 'react-router-dom';
import withTracking from 'src/hocs/with-tracking';
import OrderSimulationRouting, {
  ORDER_SIMULATION_PAGE_ROUTE,
} from 'src/pages/order-simulation/route';
import {
  UNAUTHORISED_PAGE_ROUTE,
  UnauthorisedPage,
} from 'src/pages/unauthorised';
import history from '../config/browser-history';
import RedirectStorage from '../libs/redirect';
import AuthCallbackPage, { AUTH_CALLBACK_ROUTE } from '../pages/auth-callback';
import HomePage, { HOME_PAGE_ROUTE } from '../pages/home/page';
import LoginPage, { LOGIN_PAGE_ROUTE } from '../pages/login';
import {
  ORDER_DETAILS_PAGE_ROUTE,
  OrderDetailsRoute,
  POTENTIAL_ORDER_DETAILS_PAGE_ROUTE,
} from '../pages/order-details/route';
import OrdersPageRouting, { ORDERS_PAGE_ROUTE } from '../pages/orders/route';
import PageNotFound from '../pages/page-not-found';
import ProductAvailabilityPageRouting, {
  PRODUCT_AVAILABILITY_PAGE_ROUTE,
} from '../pages/product-availability/route';
import SoldToRoute, { SOLD_TO_PAGE_ROUTE } from '../pages/sold-to/route';
import ProtectedRoute from '../route-templates/protected-route';

const redirectStorage = new RedirectStorage();
const renderAuthCallback = () => (
  <AuthCallbackPage getRedirectUrl={redirectStorage.get} />
);

const renderLogin = (
  props: RouteComponentProps<any, any, { from: string }>
) => (
  <LoginPage
    redirectUrl={props.location.state && props.location.state.from}
    storeRedirectUrl={redirectStorage.set}
  />
);
const HomePageWithTracking = withTracking(HomePage);

export default function Routes() {
  return (
    <Router history={history}>
      <Switch>
        <Route
          exact={true}
          path={AUTH_CALLBACK_ROUTE}
          render={renderAuthCallback}
        />
        <Route
          exact={true}
          path={LOGIN_PAGE_ROUTE}
          component={withTracking(renderLogin)}
        />
        <ProtectedRoute
          exact={true}
          path={HOME_PAGE_ROUTE}
          component={HomePageWithTracking}
        />
        <ProtectedRoute
          path={`${SOLD_TO_PAGE_ROUTE}/:soldToId`}
          component={withTracking(SoldToRoute)}
        />
        <ProtectedRoute
          path={`${ORDERS_PAGE_ROUTE}/:soldToId`}
          component={withTracking(OrdersPageRouting)}
        />
        <ProtectedRoute
          path={`${ORDER_DETAILS_PAGE_ROUTE}/:soldToId`}
          component={withTracking(OrderDetailsRoute)}
        />
        <ProtectedRoute
          path={`${POTENTIAL_ORDER_DETAILS_PAGE_ROUTE}/:shipToId`}
          component={withTracking(OrderDetailsRoute)}
        />
        <ProtectedRoute
          path={`${PRODUCT_AVAILABILITY_PAGE_ROUTE}/:shipToId`}
          component={withTracking(ProductAvailabilityPageRouting)}
        />
        <ProtectedRoute
          path={`${ORDER_SIMULATION_PAGE_ROUTE}/:soldToId`}
          component={withTracking(OrderSimulationRouting)}
        />
        <Route
          path={UNAUTHORISED_PAGE_ROUTE}
          component={withTracking(UnauthorisedPage)}
        />
        <Route component={withTracking(PageNotFound)} />
      </Switch>
    </Router>
  );
}
